export default __webpack_public_path__ + "img/WB_RTK_250MA_EF.58e66d45b52ecd0e16cb8f61625d6391.jpg";